import { render, staticRenderFns } from "./not-code.vue?vue&type=template&id=6a66632b&scoped=true"
import script from "./not-code.vue?vue&type=script&lang=js"
export * from "./not-code.vue?vue&type=script&lang=js"
import style0 from "./not-code.vue?vue&type=style&index=0&id=6a66632b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a66632b",
  null
  
)

export default component.exports